import { Box, Card, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DialogConfirmUpdate from './DialogConfirmUpdate';
import { firestore } from '../../../../../contexts/FirebaseContext';
import { contratosList } from '../../../../../constants/contratos';

function ContratoLicenciatario({ dataUser }) {
  const [value, setValue] = useState(contratosList.tradicional.id);
  const [openDialog, setOpenDialog] = useState(false);

  const handleChange = (event) => {
    setValue(event.target.value);
    setOpenDialog(true);
  };

  const updateContrato = async () => {
    console.log('valor actual del contrato', value);
    await firestore.collection('users').doc(dataUser.id).update({ contratoLicenciatario: value });
  };

  useEffect(() => {
    const val = dataUser?.contratoLicenciatario ? dataUser?.contratoLicenciatario : contratosList.tradicional.id;
    setValue(val);
  }, [dataUser?.contratoLicenciatario]);

  return (
    <Card sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <DialogConfirmUpdate updateContrato={updateContrato} open={openDialog} onClose={setOpenDialog} />
      <FormControl>
        <FormLabel id="demo-controlled-radio-buttons-group">Tipo contrato</FormLabel>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel
            value={contratosList.tradicional.id}
            control={<Radio />}
            label={contratosList.tradicional.label}
          />
          <FormControlLabel
            value={contratosList.inmediato.id}
            control={<Radio />}
            label={contratosList.inmediato.label}
          />
        </RadioGroup>
      </FormControl>
    </Card>
  );
}

export default ContratoLicenciatario;
